import { IMPORT_STATUS } from '../../index'
import { useQuery } from '@apollo/client'

export const useImportStatus = () => {
  const { data = {}, loading, error } = useQuery(IMPORT_STATUS)
  const { importCount } = data.importStatus || {}
  return {
    importCount,
    loading,
    error,
    data
  }
}
